import { toast } from 'react-toastify';
import appApi from '../../../../../api/app-api';
import globalSettingsStores from '../../../../../stores/settings-stores';
import { displayErrorText } from '../../../../../api/errors/api-error-codes';

export const deleteBranchOperation = async (
  branchId: number,
  setBranchId: (branchId: number | null) => void,
) => {
  try {
    setBranchId(branchId);

    const res = await appApi.deleteBranch(branchId);
    if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
    } else if (res.data.ok) {
      await globalSettingsStores.fetchSetting();
      toast.success('השלוחה נמחקה בהצלחה');
    }
    setBranchId(null);
  } catch (e) {
    setBranchId(null);
    console.error(
      `deleteBranchOperation failed with the branchId: ${branchId}, and the error: ${e}`,
    );
    toast.error('משהו קרה, נסה שוב בעוד מספר רגעים...');
  }
};
